import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { IconButton, Filter as FilterIcon, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useAppSelector } from 'app/hooks'
import { selectDashboardInfoHasFilter } from 'features/dashboardInfo/selectors'

const StyledIconButton = styled(IconButton)<{ $hasFilter: boolean }>`
  position: relative;
  &:after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: ${({ mode }) => sys[mode].interaction.primary.default};
    border-radius: 50%;
    border: 2px solid white;

    position: absolute;
    top: -4px;
    right: -4px;

    display: ${({ $hasFilter }) => ($hasFilter ? 'block' : 'none')};
  }
`

const FilterButton = ({
  onClick,
  displayFilter
}: {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  displayFilter?: boolean
}) => {
  const mode = useDisplayTheme()
  const { t } = useTranslation()
  const hasFilter = useAppSelector(selectDashboardInfoHasFilter)
  return (
    <Tooltip
      mode={mode}
      content={<span>{displayFilter ? t('hideFilters') : t('showFilters')}</span>}
      followCursor={false}
      offset={[0, 2]}>
      <StyledIconButton
        $hasFilter={hasFilter}
        mode={mode}
        color="secondary"
        variant="contained"
        onClick={onClick}>
        <FilterIcon />
      </StyledIconButton>
    </Tooltip>
  )
}

export default FilterButton
